module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textarea"
  }, [_c('Inputlabel-block', {
    staticClass: "textarea-label",
    attrs: {
      "text": _vm.label
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "textarea-textarea",
    attrs: {
      "rows": _vm.textHeight
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": _vm.changeText,
      "focus": _vm.setFocus,
      "blur": _vm.unsetFocus
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d2d31e","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/Textarea.vue
// module id = 491
// module chunks = 0